/**
 * Sekme/grup adını yerinde düzenleyen küçük giriş alanı.
 *
 * Diyalog yerine yerinde düzenleme: Chrome'da da ad, sekmenin durduğu yerde yazılıyor;
 * ayrı bir pencere açmak iki tıklık bir iş için fazla. Enter kaydeder, Esc vazgeçer,
 * odak kaybı kaydeder (kullanıcı başka yere tıkladığında yazdığı kaybolmasın).
 */
import { useEffect, useRef, useState, type KeyboardEvent } from 'react';

export interface InlineRenameProps {
  value: string;
  placeholder?: string;
  onCommit: (value: string) => void;
  onCancel: () => void;
  className?: string;
  'aria-label'?: string;
}

export function InlineRename({
  value,
  placeholder,
  onCommit,
  onCancel,
  className,
  ...aria
}: InlineRenameProps) {
  const [draft, setDraft] = useState(value);
  const ref = useRef<HTMLInputElement>(null);
  // Vazgeçildikten sonra blur'un tekrar kaydetmesini engeller.
  const done = useRef(false);

  useEffect(() => {
    ref.current?.select();
  }, []);

  const commit = () => {
    if (done.current) return;
    done.current = true;
    onCommit(draft);
  };

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (e.key === 'Enter') {
      e.preventDefault();
      commit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      done.current = true;
      onCancel();
    }
  };

  return (
    <input
      ref={ref}
      value={draft}
      placeholder={placeholder}
      aria-label={aria['aria-label']}
      onChange={(e) => setDraft(e.target.value)}
      onKeyDown={onKeyDown}
      onBlur={commit}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      className={
        className ?? 'border-brand-500 bg-bg min-w-0 flex-1 rounded border px-1 py-0 text-sm outline-none'
      }
    />
  );
}
